import React, { useEffect, useState } from 'react';
const COUNTDOWN_DURATION = 15 * 60;
const COUNTDOWN_STORAGE_KEY = 'urgency_bar_15_min_end_time';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem(COUNTDOWN_STORAGE_KEY);
    if (saved) {
      return Math.max(0, Math.floor((Number(saved) - Date.now()) / 1000));
    }
    const endTime = Date.now() + COUNTDOWN_DURATION * 1000;
    localStorage.setItem(COUNTDOWN_STORAGE_KEY, String(endTime));
    return COUNTDOWN_DURATION;
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="sticky top-0 z-50 border-b-2 border-red-600 bg-black px-4 py-3 text-white shadow-[0_4px_24px_rgba(220,38,38,0.55)]" data-id="element-383">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3" data-id="element-384">
        <div className="flex flex-col" data-id="element-385">
          <span className="text-sm md:text-base font-black tracking-wide text-red-500 animate-pulse" data-id="element-386">
            🔥 ¡OFERTA EXCLUSIVA!
          </span>
          <span className="text-xs md:text-sm font-semibold text-red-100" data-id="element-387">
            50% OFF termina en:
          </span>
        </div>

        <div className="flex items-center gap-1 md:gap-2" data-id="element-388">
          <div className="rounded-md border border-red-600 bg-red-950 px-2 py-1 text-center min-w-[40px] md:min-w-[52px] shadow-[0_0_12px_rgba(220,38,38,0.45)]" data-id="element-389">
            <span className="text-lg md:text-2xl font-black tabular-nums text-red-400" data-id="element-390">
              {pad(hours)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-red-200 uppercase tracking-wider" data-id="element-391">
              HRS
            </p>
          </div>
          <span className="text-xl md:text-2xl font-black text-red-500" data-id="element-392">:</span>
          <div className="rounded-md border border-red-600 bg-red-950 px-2 py-1 text-center min-w-[40px] md:min-w-[52px] shadow-[0_0_12px_rgba(220,38,38,0.45)]" data-id="element-393">
            <span className="text-lg md:text-2xl font-black tabular-nums text-red-400" data-id="element-394">
              {pad(minutes)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-red-200 uppercase tracking-wider" data-id="element-395">
              MIN
            </p>
          </div>
          <span className="text-xl md:text-2xl font-black text-red-500" data-id="element-396">:</span>
          <div className="rounded-md border border-red-600 bg-red-950 px-2 py-1 text-center min-w-[40px] md:min-w-[52px] shadow-[0_0_12px_rgba(220,38,38,0.45)]" data-id="element-397">
            <span className="text-lg md:text-2xl font-black tabular-nums text-red-400" data-id="element-398">
              {pad(seconds)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-red-200 uppercase tracking-wider" data-id="element-399">
              SEG
            </p>
          </div>
        </div>
      </div>
    </div>;
}